export const FRACTAL_DOMAIN = 'fractal.is';
export const FRACTAL_DOMAIN_HTTPS = 'https://fractal.is';
export const FRACTAL_DOMAIN_HTTPS_WWW = 'https://www.fractal.is';
export const DEFAULT_POPUP_WIDTH_PX = 400;
export const DEFAULT_POPUP_HEIGHT_PX = 600;
//# sourceMappingURL=constants.js.map